export const navigationItems = [
  { label: "Anasayfa", path: "/" },
  { label: "Hakkimda", path: "/hakkimda" },
  { label: "MyAppShop", path: "/myappshop" },
  { label: "Blog", path: "/blog" },
  { label: "Iletisim", path: "/iletisim" },
];

export const socialLinks = [
  { label: "LinkedIn", value: "@onuratabay", href: "https://linkedin.com" },
  { label: "GitHub", value: "@onuratabay", href: "https://github.com" },
  { label: "X", value: "@onuratabay", href: "https://x.com" },
];

export const siteProfile = {
  name: "Onur Atabay",
  role: "Frontend Architect & Product Builder",
  shortBio:
    "Premium dijital urunler, headless icerik deneyimleri ve yuksek donusumlu arayuzler tasarliyor, geliştiriyorum.",
  extendedBio:
    "Marka hissi guclu, performans odakli ve uzun omurlu web deneyimleri ureten bir urun odakli frontend geliştiricisiyim. Tasarim ile muhendislik arasindaki gri alan benim en guclu calisma alanim.",
  email: "hello@onuratabay.com",
  location: "Istanbul, Turkiye",
  sameAs: socialLinks.map((item) => item.href),
};

export const featuredMetrics = [
  { label: "Canli urun", value: "12+", note: "Web, mobil ve dashboard projeleri" },
  { label: "Ortalama teslim", value: "6 hf", note: "Konseptten production'a" },
  { label: "Odak", value: "%100", note: "UX kalitesi ve is etkisi" },
];

export const expertiseAreas = [
  "React mimarisi",
  "Design systems",
  "Headless CMS entegrasyonu",
  "Conversion-driven UI",
  "Responsive premium arayuzler",
  "Frontend performansi",
];

export const technologyStack = [
  "React",
  "TypeScript hazir mimari",
  "WordPress Headless",
  "REST API",
  "Node.js",
  "Design Tokens",
  "Figma handoff",
  "Analytics",
];

export const careerHighlights = [
  {
    title: "Senior Frontend Consultant",
    period: "2023 - Bugun",
    description:
      "Kisisel markalar ve urun ekipleri icin premium web deneyimleri, dashboard'lar ve reusable component altyapilari tasarladim.",
  },
  {
    title: "Product UI Engineer",
    period: "2020 - 2023",
    description:
      "Uygulama marketleri, landing page'ler ve SaaS urunleri icin performans odakli React arayuzleri gelistirdim.",
  },
  {
    title: "Frontend Developer",
    period: "2017 - 2020",
    description:
      "Tasarim sistemleri, CMS entegrasyonlari ve responsive site altyapilarinda uzmanlastim.",
  },
];

export const skillCards = [
  {
    title: "UI Architecture",
    description: "Buyuyebilen component ekosistemleri ve sistematik arayuz kararlarina odaklanirim.",
  },
  {
    title: "Product Thinking",
    description: "Sadece guzel ekranlar degil, donusum ve kullanici akisi da tasarlarim.",
  },
  {
    title: "Execution Quality",
    description: "Animasyon, spacing, mikro detaylar ve responsive davranis benim icin sonradan eklenen seyler degil.",
  },
];

export const apps = [
  {
    id: "fitflow-mobile",
    slug: "fitflow-mobile",
    name: "FitFlow Mobile",
    category: "Health",
    platform: ["iOS", "Android"],
    status: "Live",
    summary: "Abonelik ve gunluk ilerleme takibi odakli saglik uygulamasi.",
    description:
      "Dark glass dashboard dili, premium onboarding ve retention odakli bildirim akislariyla kurgulanan mobil deneyim.",
    tags: ["React Native", "Subscription", "Analytics"],
    storeUrl: "#",
    demoUrl: "#",
    featured: true,
  },
  {
    id: "merchant-web-suite",
    slug: "merchant-web-suite",
    name: "Merchant Web Suite",
    category: "SaaS",
    platform: ["Web"],
    status: "Beta",
    summary: "Operasyon yonetimi ve raporlama ekranlari sunan web paneli.",
    description:
      "Moduler dashboard yapisi, grafik odakli bilgi mimarisi ve ekip bazli erisim senaryolariyla tasarlandi.",
    tags: ["Dashboard", "Admin", "Reporting"],
    storeUrl: "#",
    demoUrl: "#",
    featured: true,
  },
  {
    id: "nova-commerce",
    slug: "nova-commerce",
    name: "Nova Commerce",
    category: "Commerce",
    platform: ["iOS", "Web"],
    status: "Concept",
    summary: "Yeni nesil urun kesfi ve premium checkout deneyimi.",
    description:
      "Marka odakli urun vitrini, editorial landing akislari ve conversion optimize checkout yapisiyla gelistirildi.",
    tags: ["E-commerce", "UX", "Prototype"],
    storeUrl: "#",
    demoUrl: "#",
    featured: false,
  },
  {
    id: "taskpilot",
    slug: "taskpilot",
    name: "TaskPilot",
    category: "Productivity",
    platform: ["Android", "Web"],
    status: "Live",
    summary: "Bireysel ve ekip odakli gorev yonetimi uygulamasi.",
    description:
      "Minimal gorev akislari, bildirim mantigi ve hizli filtreleme sistemi ile daha akici bir calisma deneyimi sunar.",
    tags: ["Task", "Team", "Automation"],
    storeUrl: "#",
    demoUrl: "#",
    featured: false,
  },
];

export const appCategories = ["All", "Health", "SaaS", "Commerce", "Productivity"];
export const appPlatforms = ["All", "iOS", "Android", "Web"];

export const blogPosts = [
  {
    id: "crafting-premium-interfaces",
    slug: "crafting-premium-interfaces",
    title: "Premium arayuzler neden sadece gorsellikle ilgili degildir?",
    category: "Design Systems",
    readingTime: "6 dk",
    publishedAt: "2026-04-10",
    excerpt:
      "Urun kalitesi hissi; spacing, motion, copy tonu ve mikro davranislarin birlikte calismasiyla olusur.",
    cover:
      "Soft glow arka plan uzerinde cam panel estetikli modern urun arayuzu konsepti",
    content:
      "Premium his, pahali gozukmekten daha farkli bir seydir. Gercek kalite; tutarlilik, hiz, okunabilirlik ve karar yorgunlugunu azaltan bir bilgi mimarisiyle ortaya cikar. Bir arayuzde kullanicinin ne hissedecegini tasarim token'lari kadar gecisler, bosluklar ve durum mesajlari da belirler.",
    featured: true,
    tags: ["UX", "Premium UI", "Frontend"],
  },
  {
    id: "headless-wordpress-for-personal-brand",
    slug: "headless-wordpress-for-personal-brand",
    title: "Kisisel marka sitesi icin headless WordPress neden mantikli?",
    category: "CMS",
    readingTime: "4 dk",
    publishedAt: "2026-04-05",
    excerpt:
      "Icerik yonetimini editor dostu tutarken frontend kalitesinden odun vermemek isteyenler icin pratik bir yol.",
    cover:
      "Koyu tonlu CMS paneli ve modern frontend katmani iliskisini anlatan konsept",
    content:
      "Headless WordPress, editor konforu ile ozel frontend deneyimini ayni anda elde etmek icin oldukca pragmatik bir model sunar. Ozellikle blog ve landing sayfalarini birlikte yoneten kisisel markalar icin guclu bir esneklik saglar.",
    featured: false,
    tags: ["WordPress", "CMS", "Architecture"],
  },
  {
    id: "react-project-structure-that-scales",
    slug: "react-project-structure-that-scales",
    title: "Buyuyebilen React klasor yapisi nasil kurulur?",
    category: "React",
    readingTime: "7 dk",
    publishedAt: "2026-03-28",
    excerpt:
      "Kucuk baslayip buyuk dusunen ekipler icin pages, features ve shared katmanlarinin rolu.",
    cover:
      "Kod editoru ve katmanli proje mimarisi bloklarini gosteren teknik konsept",
    content:
      "Sik yapilan hata, ya cok erken enterprise karmasina gitmek ya da her seyi tek klasorde biriktirmektir. Dengeli cozum, tekrar kullanimi destekleyen ama domain sinirlarini da koruyan bir yapidir.",
    featured: false,
    tags: ["React", "Scalability", "Architecture"],
  },
  {
    id: "motion-that-feels-expensive",
    slug: "motion-that-feels-expensive",
    title: "Pahali hissettiren motion tasarimi nasil kurulur?",
    category: "Motion",
    readingTime: "5 dk",
    publishedAt: "2026-03-20",
    excerpt:
      "Abartisiz gecisler, yumusak easing ve katmanli giris animasyonlari ile kalite hissi yaratmak.",
    cover:
      "iOS benzeri motion ve blur katmanlarini temsil eden dinamik premium arayuz",
    content:
      "Motion'in gorevi dikkat dagitmak degil, etkileşimin kalitesini hissettirmektir. Hedef, kullaniciyi hareketle yormadan arabirimdeki niyeti guclendirmektir.",
    featured: false,
    tags: ["Animation", "Motion", "Design"],
  },
];

export const blogCategories = ["All", "Design Systems", "CMS", "React", "Motion"];

export const contactChannels = [
  {
    label: "E-posta",
    value: siteProfile.email,
    description: "Yeni proje, danismanlik veya is ortakligi icin en hizli kanal.",
  },
  {
    label: "Konum",
    value: siteProfile.location,
    description: "Remote ve hibrit is birliklerine acigim.",
  },
  {
    label: "Donus suresi",
    value: "24 saat",
    description: "Net scope ile gelen taleplere genelde ayni gun donuyorum.",
  },
];

export const homepageSections = {
  heroHighlights: [
    "Premium product websites",
    "Headless CMS-friendly architecture",
    "Conversion-aware UX systems",
  ],
  ctaPrimary: "Bir proje konusalim",
  ctaSecondary: "MyAppShop'u kesfet",
};
